import React, {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import jwt_decode from "jwt-decode";
import BottomButton from "@/view/common/component/button/BottomButton";
import Input from "@/view/common/component/Input";
import Icon from "@/view/common/component/Icon";
import Popup from "@/view/common/popup/Popup";
import UserService, {SvcUserSignUp, SvcUser} from "@/service/UserService"
import StringUtil from "@/common/StringUtil";
import ValidateUtil from "@/common/ValidateUtil";
import GenderSelect from '@/view/common/component/GenderSelect'


export interface SignupDetailConfig {
    email?: string
    prevType?: string
    uuid?: string
}

const Signup = (props:SignupDetailConfig) => {
    const navigate = useNavigate()
    const messageList = {
        'email': {'label':'이메일', 'name':'email', 'title': '메일 주소를 입력해주세요', 'subTitle': '아이디로 쓰일 주소예요'},
        'pwd': {'label':'비밀번호', 'name':'pwd', 'title': '비밀번호를 입력해주세요', 'subTitle': '영문, 숫자 포함 10자 이상이에요'},
        'pwdCheck': {'label':'비밀번호', 'name':'pwdCheck', 'title': '비밀번호를 확인해주세요', 'subTitle': '영문, 숫자 포함 10자 이상이에요'},
        'nickName': {'label':'닉네임', 'name':'nickNm', 'title': '닉네임을 입력해주세요', 'subTitle': '20자 이내로 입력해주세요'},
        'tall': {'label':'키', 'name':'tall', 'title': '키를 알려주세요', 'subTitle': '소수점 첫 번째 자리까지 입력할 수 있어요'},
        'gender': {'label':'성별', 'name':'gender', 'title': '성별을 선택해 주세요', 'subTitle': ''},
        'birthday': {'label':'생년월일', 'name':'birthday', 'title': '생년월일을 입력해 주세요', 'subTitle': '8글자로 입력해주세요'},
        'sns': {'label':'', 'name':'', 'title': 'SNS 회원가입', 'subTitle': '비밀번호 없이 사용하는 SNS 회원가입이에요'},
        'complete': {'label':'', 'name':'', 'title': '정보를 확인 해 주세요', 'subTitle': '입력하신 정보가 맞나요?'},
    }
    const [message, setMessage] = useState(messageList.email)
    const defaultTheme = 'dark'


    const [_mnbrNtrySeCd] = useState(props.prevType?props.prevType:'')
    const [_uuid] = useState(props.uuid)
    const [email, setEmail] = useState({value:props.email?props.email:'', errMsg: ''})
    const [pwd, setPwd] = useState({value:'', errMsg: ''})
    const [pwdCheck, setPwdCheck] = useState({value:'', errMsg: ''})
    const [nickName, setNickName] = useState({value:'', errMsg: ''})
    const [tall, setTall] = useState({value:'', errMsg: ''})
    const [gender, setGender] = useState({value: '', errMsg:''})
    const [birthday, setBirthday] = useState({value:'', errMsg:''})

    const [typePassword, setTypePassword] = useState('password')
    const [typePassword2, setTypePassword2] = useState('password')
    const [disable, setDisable] = useState(true)

    type DecodedToken = {
        email: string
    }

    useEffect(()=> {
        if(_uuid){
            let decodedToken:DecodedToken = {email:''}
            if(_mnbrNtrySeCd === 'A'){
                    decodedToken = jwt_decode(_uuid);
                    if(decodedToken.email){
                        setEmail({value:decodedToken.email, errMsg: ''})
                    }
            }
        }
    }, [_uuid])

    useEffect(()=> {

        if(_mnbrNtrySeCd === 'G' || _mnbrNtrySeCd === 'N' || _mnbrNtrySeCd === 'K' || _mnbrNtrySeCd === 'A'){
            pwd.value= _mnbrNtrySeCd
            pwdCheck.value= _mnbrNtrySeCd
            setMessage(messageList.sns)
        }
    }, [_mnbrNtrySeCd])

    useEffect(()=> {
        if(StringUtil.isEmpty(email.value)
            || StringUtil.isEmpty(pwd.value)
            || StringUtil.isEmpty(pwdCheck.value)
            || StringUtil.isEmpty(nickName.value)
        ){
            setDisable(true)
        }else if(StringUtil.isNotEmpty(email.errMsg)
            || StringUtil.isNotEmpty(pwd.errMsg)
            || StringUtil.isNotEmpty(pwdCheck.errMsg)
            || StringUtil.isNotEmpty(nickName.errMsg)
        ){
            setDisable(true)
        }else{
            setDisable(false)
            setMessage(messageList.complete)
        }
    }, [email, pwd, pwdCheck, nickName, tall, gender, birthday])

    const svcUser = new SvcUserSignUp(
        '',
        '',
        '',
    )

    const {refetch: signUp} = useQuery<any, AxiosError>(
        ['signUp'],
        ()=> UserService.signUp(svcUser),
        {
            onSuccess: (data: SvcUser) => {
                signUpSuccess(data)
            }
        }
    )

    const signUpSuccess = (data: SvcUser) => {
        navigate('/')
    }

    const [isOpen, setIsOpen] = useState(false)

    let flag = false
    const clickSignUp = async() => {
        if(flag) return
        flag = true
        svcUser.nickName = nickName.value
        svcUser.userEmail = email.value
        svcUser.pwd = pwd.value

        await signUp()
        flag = false
    }

    const clearBirthday = () => {
        setBirthday({value:'', errMsg:''})
    }

    let ignore2 = false
    const validateNickName = async (value: string) => {
        if(ignore2)
            return;
        ignore2 = true;
        const result = ValidateUtil.checkValidNickName(value)
        if(StringUtil.isNotEmpty(result.value) && StringUtil.isEmpty(result.errMsg)){
            await ValidateUtil.checkDuplicate(result.value).then(res=> {
                if(!res) {
                    setNickName({value: result.value, errMsg: '사용하실 수 없는 닉네임이에요.'})
                }else{
                    setNickName(prevState => ({value: prevState.value, errMsg: ''}))
                }
            }).catch(() => {console.log('시스템 에러')})
        } else {
            setNickName({value:result.value, errMsg: result.errMsg})
        }
        ignore2 = false
    }

    const clearNickName = () => {
        setNickName({value: '', errMsg: ''})
    }

    const validateTall = (value:string) => {
        const result = ValidateUtil.checkValidTall(value)
        setTall({value: result.value, errMsg: result.errMsg})
    }

    const validateBirthday = (value:string) =>{
        const result = ValidateUtil.checkValidBirthday(value)
        setBirthday({value: result.value, errMsg: result.errMsg})
    }

    let ignore = false
    const validateEmail = async(value:string) =>{
        if(ignore)
            return;
        ignore = true;
        const result = ValidateUtil.checkValidEmail(value)
        if(StringUtil.isNotEmpty(result.value) && StringUtil.isEmpty(result.errMsg)){
            await ValidateUtil.checkEmailDuplicate(result.value).then(res=> {
                if(!res) {
                    setEmail({value: result.value, errMsg: '다른 사람이 사용 중인 이메일이에요.'})
                }else{
                    setEmail(prevState => ({value: prevState.value, errMsg: ''}))
                }
            }).catch(() => {console.log('시스템 에러')})
        } else {
            setEmail({value:result.value, errMsg: result.errMsg})
        }
        ignore = false;
    }

    const validatePwd = (value:string) =>{
        const result = ValidateUtil.checkValidPwd(value)
        setPwd({value: result.value, errMsg: result.errMsg})
    }

    const validatePwdOnBlur = (value:string) =>{
        const result = ValidateUtil.checkValidPwd(value)
        setPwd({value: result.value, errMsg: result.errMsg})
        if(StringUtil.isEmpty(result.errMsg) && StringUtil.isNotEmpty(pwd.value) && StringUtil.isNotEmpty(pwdCheck.value)){
            if(pwd.value !== pwdCheck.value) {
                setPwd({value: result.value, errMsg: '비밀번호가 일치하지 않아요.'})
            }else{
                setPwdCheck({value: pwdCheck.value, errMsg: ''})
            }
        }

    }

    const validatePwdCheck = (value:string) =>{
        const result = ValidateUtil.checkValidPwd(value)
        setPwdCheck({value: result.value, errMsg: result.errMsg})
    }

    const validatePwdCheckOnBlur = (value:string) =>{
        const result = ValidateUtil.checkValidPwd(value)
        setPwdCheck({value: result.value, errMsg: result.errMsg})
        if(StringUtil.isEmpty(result.errMsg) && StringUtil.isNotEmpty(pwd.value) && StringUtil.isNotEmpty(pwdCheck.value)){
            if(pwd.value !== pwdCheck.value) {
                setPwdCheck({value: result.value, errMsg: '비밀번호가 일치하지 않아요.'})
            }else{
                setPwd({value: pwd.value, errMsg: ''})
            }
        }
    }

    const clickLook = () => {
        if(typePassword === 'text'){
            setTypePassword('password')
        }else{
            setTypePassword('text')
        }
    }

    const clickLook2 = () => {
        if(typePassword2 === 'text'){
            setTypePassword2('password')
        }else{
            setTypePassword2('text')
        }
    }

    const genderClicked = () => {
        setMessage(messageList.gender)
        setIsOpen(true)
    }

    const genderSelected = (value:string) => {
        setGender(prevState => ({value: ValidateUtil.convertGenderName(value), errMsg: prevState.errMsg}))
        setIsOpen(false)
    }

    useEffect(()=>{
        if(StringUtil.isNotEmpty(nickName.value) || StringUtil.isNotEmpty(nickName.errMsg)){
            if(StringUtil.isEmpty(nickName.value)){
                setNickName(prevState => ({value: prevState.value, errMsg: '닉네임을 입력해주세요'}))
            }else{
                setNickName(prevState => ({value: prevState.value, errMsg: prevState.errMsg}))
            }
        }
    }, [nickName.value, nickName.errMsg])

    return (
        <>
            <div id='Signup' className={'bg-cl-black'}>
                <div className={'main-content'}>
                    <div className={'h5_m title mt-39px'}>{message.title}</div>
                    <div className={'b2_r title mt-16px ft-cl-hint'}>{message.subTitle}</div>
                    <div className={'input-wrapper'}>
                        <div className={'b1_r input-item'}>
                    {
                        _mnbrNtrySeCd === 'G' || _mnbrNtrySeCd === 'N'||  _mnbrNtrySeCd === 'K'||  _mnbrNtrySeCd === 'A'?
                            <Input theme={defaultTheme}
                                   label={messageList.email.label}
                                   name={messageList.email.name}
                                   value={email.value}
                                   required={true}
                                   errorMsg={email.errMsg}
                                   readOnly={true}
                            >
                                {email.value}
                            </Input>
                        :
                            <Input theme={defaultTheme}
                                   label={messageList.email.label}
                                   name={messageList.email.name}
                                   value={email.value}
                                   rightContent={<div className={'click-area'} onClick={() => setEmail({value: '', errMsg: ''})}><Icon iconClass={'input-delete-d h-17px'}/></div>}
                                   onChange={(ev) => setEmail(prevState => ({value: ev.target.value, errMsg: prevState.errMsg}))}
                                   required={true}
                                   onBlur={() => validateEmail(email.value)}
                                   onKeyUp={() => validateEmail(email.value)}
                                   onClick={() => setMessage(messageList.email)}
                                   errorMsg={email.errMsg}
                            >
                                {email.value}
                            </Input>
                    }
                        </div>
                        {
                            _mnbrNtrySeCd === 'G' || _mnbrNtrySeCd === 'N' || _mnbrNtrySeCd === 'K' || _mnbrNtrySeCd === 'A' ?
                                <></>
                            :
                                <div>
                                    <div className={'b1_r input-item'}>
                                        <Input theme={defaultTheme}
                                               label={messageList.pwd.label}
                                               name={messageList.pwd.name}
                                               value={pwd.value}
                                               rightContent={<div className={'click-area'} onClick={() => clickLook()}><Icon
                                                   iconClass={'ic-look h-17px'}/></div>}
                                               onChange={(ev) => setPwd(prevState => ({
                                                   value: ev.target.value,
                                                   errMsg: prevState.errMsg
                                               }))}
                                               required={true}
                                               onBlur={() => validatePwdOnBlur(pwd.value)}
                                               onKeyUp={() => validatePwd(pwd.value)}
                                               onClick={() => setMessage(messageList.pwd)}
                                               errorMsg={pwd.errMsg}
                                               type={typePassword}
                                        >
                                            {pwd.value}
                                        </Input>
                                    </div>
                                    <div className={'b1_r input-item'}>
                                        <Input theme={defaultTheme}
                                               label={messageList.pwdCheck.label}
                                               name={messageList.pwdCheck.name}
                                               value={pwdCheck.value}
                                               rightContent={<div className={'click-area'} onClick={() => clickLook2()}>
                                                   <Icon iconClass={'ic-look h-17px'}/></div>}
                                               onChange={(ev) => setPwdCheck(prevState => ({
                                                   value: ev.target.value,
                                                   errMsg: prevState.errMsg
                                               }))}
                                               required={true}
                                               onBlur={() => validatePwdCheckOnBlur(pwdCheck.value)}
                                               onKeyUp={() => validatePwdCheck(pwdCheck.value)}
                                               onClick={() => setMessage(messageList.pwdCheck)}
                                               errorMsg={pwdCheck.errMsg}
                                               type={typePassword2}
                                        >
                                            {pwdCheck.value}
                                        </Input>
                                    </div>
                                </div>
                        }
                        <div className={'b1_r input-item'}>
                            <Input theme={defaultTheme}
                                   label={'닉네임'}
                                   name={'nickName'}
                                   value={nickName.value}
                                   rightContent={<div className={'click-area'} onClick={() => clearNickName()}><Icon iconClass={'input-delete-d h-17px'}/></div>}
                                   onChange={(ev) => setNickName(prevState => ({value: ev.target.value, errMsg: prevState.errMsg}))}
                                   //onChange={(ev) => validateNickName(ev.target.value)}
                                   onBlur={() => validateNickName(nickName.value)}
                                   onKeyUp={() => validateNickName(nickName.value)}
                                   required={true}
                                   errorMsg={nickName.errMsg}
                                   onClick={() => setMessage(messageList.nickName)}
                            />
                        </div>
                        {/*<div className={'b1_r input-item'}>*/}
                        {/*    <Input theme={defaultTheme}*/}
                        {/*           label={messageList.tall.label}*/}
                        {/*           name={messageList.tall.name}*/}
                        {/*           value={tall.value}*/}
                        {/*           rightContent={<div className={'click-area'} onClick={() => setTall({value: '', errMsg: ''})}><Icon iconClass={'input-delete-d h-17px'}/></div>}*/}
                        {/*           required={true}*/}
                        {/*           onChange={(ev) => setTall(prevState => ({value: ev.target.value, errMsg: prevState.errMsg}))}*/}
                        {/*           maxLength={5}*/}
                        {/*           errorMsg={tall.errMsg}*/}
                        {/*           onBlur={() => validateTall(tall.value)}*/}
                        {/*           onKeyUp={() => validateTall(tall.value)}*/}
                        {/*           onClick={() => setMessage(messageList.tall)}*/}
                        {/*    >*/}
                        {/*        {tall.value}*/}
                        {/*    </Input>*/}
                        {/*</div>*/}
                        {/*<div className={'b1_r input-item'}>*/}
                        {/*    <Input theme={defaultTheme}*/}
                        {/*           label={messageList.gender.label}*/}
                        {/*           name={messageList.gender.name}*/}
                        {/*           value={gender.value}*/}
                        {/*           rightContent={<div onClick={()=> genderClicked()}><Icon iconClass={'expend-off'}/></div>}*/}
                        {/*           required={true}*/}
                        {/*           readOnly={true}*/}
                        {/*           onClick={() =>genderClicked()}*/}
                        {/*           onBlur={() =>setGender(prevState => ({value:prevState.value, errMsg:prevState.errMsg}))}*/}
                        {/*           errorMsg={gender.errMsg}*/}
                        {/*    />*/}
                        {/*</div>*/}
                        {/*<div className={'b1_r input-item'}>*/}
                        {/*    <Input theme={defaultTheme}*/}
                        {/*           label={messageList.birthday.label}*/}
                        {/*           name={messageList.birthday.name}*/}
                        {/*           value={birthday.value}*/}
                        {/*           rightContent={<div className={'click-area'} onClick={() => clearBirthday()}><Icon iconClass={'input-delete-d h-17px'}/></div>}*/}
                        {/*           required={true}*/}
                        {/*           onChange={(ev) => setBirthday(prevState => ({value: ev.target.value, errMsg: prevState.errMsg}))}*/}
                        {/*           onBlur={() => validateBirthday(birthday.value)}*/}
                        {/*           onKeyUp={() => validateBirthday(birthday.value)}*/}
                        {/*           onClick={() => setMessage(messageList.birthday)}*/}
                        {/*           errorMsg={birthday.errMsg}*/}
                        {/*           maxLength={8}*/}

                        {/*    />*/}
                        {/*</div>*/}
                        <div className={'h-48px'}></div>
                    </div>
                </div>

                {

                    !disable ?
                        <BottomButton title={'완료'} disabled={false} onClick={() => clickSignUp()} />
                        :
                        <BottomButton title={'완료'} disabled={true}  />
                }

            </div>
            <Popup className='bg-cl-gray-2 ft-cl-white' title='성별 선택' iconClass={'close-w'} content={<GenderSelect onClick={genderSelected} className={defaultTheme} selected={gender.value}/>} isOpen={isOpen} onClose={ () => setIsOpen(!isOpen) }/>
        </>
    )
}

export default Signup